import type { Member } from '@wix/ambassador-blog-frontend-adapter-public-v2-post-page/types';
import { BLOG_APP_ID } from '@wix/communities-universal/dist/src/constants/appsConfig';

export const getUserRoleByApp = (
  user: Member | undefined,
  appDefinitionId: string,
) => user?.appStore?.[appDefinitionId]?.permissions?.role;
export const getUserRole = (user: Member | undefined) =>
  getUserRoleByApp(user, BLOG_APP_ID);
